function setComparisonAndFavorites() {
    withFetch(APP.GET_FAVORITE_URL, card => {
        card.classList.add('_favorite');
    })

    withFetch(APP.GET_COMPARE_URL, card => {
        card.classList.add('_compare');
    })

    async function withFetch(url, callback) {
        try {
            const res = await fetch(url);
            const json = await res.json();
            const data = json.data;

            data.length && data.forEach(({product_id}) => {
                const btns = document.querySelectorAll(`[data-product-id="${product_id}"]`);

                if (!btns.length) return;

                btns.forEach(btn => {
                    const card = btn.closest('.product-card') || btn.closest('.js-product-to-cart-btn');

                    if (card) {
                        callback(card);
                    }
                })
            })
        } catch (e) {
            console.log(e);
        }
    }
}
